<template>
  <main>
    <div class="hubday-tabs">
      <div class="hubday-section">
        <div class="hubday-head">
          <i class="material-icons-outlined">calendar_today</i>Événements
        </div>
        <div class="hubday-body">
          <transition name="next" mode="out-in">
            <div id="calendar" class="calendar">
              <div class="head">
                <transition :name="transition" mode="out-in">
                  <div class="month" :key="month">
                    <i class="icon-calendar"></i>
                    <strong>{{ month }}</strong>
                    <span>{{ year }}</span>
                  </div>
                </transition>
                <div class="controls">
                  <button @click="updateCalendar(-1)">&lt;</button>
                  <span>/</span>
                  <button @click="updateCalendar(1)">&gt;</button>
                </div>
              </div>
              <transition :name="transition" mode="out-in">
                <div class="bodyContainer" :key="eventsHTML">
                  <div class="body" :class="rows" v-html="eventsHTML">{{ eventsHTML }}</div>
                </div>
              </transition>
            </div>
          </transition>
        </div>
      </div>
    </div>
  </main>
</template>

<style>
.hoverable {
  cursor: pointer;
}
</style>

<style scoped>
strong {
  font-weight: 600;
}

.hubday-body {
  padding: 20px 0 0 0;
}

.bodyContainer .body {
  padding: 0 20px 20px 20px;
}

.hubday-section {
  width: 100%;
  max-width: 1300px;
  margin: auto;
}

.next-enter-active,
.next-leave-active,
.previous-enter-active,
.previous-leave-active {
  transition: all 0.2s;
}
.next-enter,
.next-leave-active,
.previous-enter,
.previous-leave-active {
  opacity: 0;
}
.next-enter,
.previous-leave-active {
  transform: translateX(31px);
}
.next-leave-active,
.previous-enter {
  transform: translateX(-31px);
}

.calendar .body.rows-6 {
  grid-template-rows: 30px repeat(6, 1fr);
}

.calendar .body.rows-5 {
  grid-template-rows: 30px repeat(5, 1fr);
}

.calendar .body.rows-4 {
  grid-template-rows: 30px repeat(4, 1fr);
}
</style>

<script>
import { mapState } from "vuex";
import M from "materialize-css";

import * as firebase from "firebase/app";
import "firebase/database";
const rtdb = firebase.database();
var worksRef = rtdb.ref("events");

export default {
  computed: {
    ...mapState(["userProfile"]),
  },
  data() {
    return {
      today: new Date(),
      date: null,
      monthList: [
        "janvier",
        "février",
        "mars",
        "avril",
        "mai",
        "juin",
        "juillet",
        "aôut",
        "septembre",
        "octobre",
        "novembre",
        "décembre",
      ],
      dayList: [
        "lundi",
        "mardi",
        "mercredi",
        "jeudi",
        "vendredi",
        "samedi",
        "dimanche",
      ],
      month: null,
      year: null,
      currentMonth: null,
      transition: "next",
      eventsHTML: null,
      rows: "rows-4",
      events: {},
    };
  },
  methods: {
    getFrDay(date) {
      return date.getDay() == 0 ? 6 : date.getDay() - 1;
    },
    formatDate(date) {
      var d = new Date(date),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear();

      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;

      return [year, month, day].join("-");
    },
    updateCalendar(step) {
      this.transition = step < 0 ? "previous" : step > 0 ? "next" : "";
      this.date.setMonth(this.date.getMonth() + step);

      if (this.date.toJSON() <= new Date("2020-08-31").toJSON()) {
        this.date = new Date("2020-09-01");
        M.toast({ html: "Impossible de reculer plus !" });
      } else if (this.date.toJSON() >= new Date("2021-07-01").toJSON()) {
        this.date = new Date("2021-06-01");
        M.toast({ html: "Impossible d'avancer plus !" });
      }

      this.month = this.monthList[this.date.getMonth()].toUpperCase();
      this.year = this.date.getFullYear();

      this.currentMonth = new Date(
        this.date.getFullYear(),
        this.date.getMonth(),
        1
      );

      this.eventsHTML = "";

      for (let i = 0; i < this.dayList.length; i++) {
        this.eventsHTML +=
          "<div class='cell day'>" + this.dayList[i].toUpperCase() + "</div>";
      }

      for (let i = 0; i < this.getFrDay(this.currentMonth); i++) {
        this.eventsHTML += "<div class='cell empty'></div>";
      }

      // Nombre de jour dans le mois affiché
      let monthLength = new Date(
        this.date.getFullYear(),
        this.date.getMonth() + 1,
        0
      ).getDate();

      // Création des cellules contenant les jours du mois affiché
      for (let i = 1; i <= monthLength; i++) {
        // Timestamp de la cellule
        let timestamp = this.formatDate(
          new Date(this.date.getFullYear(), this.date.getMonth(), i)
        );

        var today = timestamp == this.formatDate(new Date());

        this.eventsHTML +=
          "<div class='cell hoverable" + (today ? " today" : "") + "'>" + i;
        if (this.events[timestamp] !== undefined) {
          for (var event of this.events[timestamp]) {
            this.eventsHTML += "<div class='event'>" + event["name"] + "</div>";
          }
        }
        this.eventsHTML += "</div>";
      }

      if (this.getFrDay(this.currentMonth) + monthLength > 35) {
        // Création des cellules vides si nécessaire
        for (
          let i = this.getFrDay(this.currentMonth) + monthLength;
          i < 42;
          i++
        ) {
          this.eventsHTML += "<div class='cell empty'></div>";
        }
        this.rows = "rows-6";
      } else if (this.getFrDay(this.currentMonth) + monthLength > 28) {
        for (
          let i = this.getFrDay(this.currentMonth) + monthLength;
          i < 35;
          i++
        ) {
          this.eventsHTML += "<div class='cell empty'></div>";
        }
        this.rows = "rows-5";
      } else {
        this.rows = "rows-4";
      }
    },
  },
  mounted() {
    this.today.setHours(0, 0, 0, 0);
    this.date = new Date();
    if (this.date.toJSON() <= new Date("2020-08-31").toJSON())
      this.date = new Date("2020-09-01");
    this.date.setHours(0, 0, 0, 0);
    var self = this;
    worksRef.on("value", function (snapshot) {
      self.events = snapshot.val();
      self.updateCalendar(0);
    });
  },
};
</script>